// import {format} from 'date-fns'

class HelpText {
  constructor(data) {
    this.pk = data.pk;
    this.controlId = data.control_id || '';
    this.contextId = data.context_id || '';
    this.helpText = data.help_text || '';
    this.isActive = data.is_active ?? true;
    this.extraData = data.extra_data ?? {};
  }
}
export default HelpText;